import request from '@/utils/request'
export function fetchList(params) {
  return request({
    url:'/order/admin/orderInfo/list',
    method:'post',
    data:params
  })
}

export function delivery(data) {
  return request({
    url:'/order/admin/orderInfo/delivery',
    method:'post',
    data:data
  })
}

export function deliveryBath(params) {
  return request({
    url:'/order/admin/orderInfo/deliveryBath',
    method:'post',
    params:params
  })
}

export function orderChart(params) {
  return request({
    url:'/order/admin/orderInfo/chart',
    method:'get',
    params:params
  })
}

export function deleteOrder(params) {
  return request({
    url:'/order/delete',
    method:'post',
    params:params
  })
}

export function deliveryOrder(data) {
  return request({
    url:'/order/update/delivery',
    method:'post',
    data:data
  });
}

export function getOrderDetail(id) {
  return request({
    url:'/order/admin/orderInfo/query/'+id,
    method:'get'
  });
}

export function updateReceiverInfo(data) {
  return request({
    url:'/order/update/receiverInfo',
    method:'post',
    data:data
  });
}

export function updateMoneyInfo(data) {
  return request({
    url:'/order/update/moneyInfo',
    method:'post',
    data:data
  });
}

export function updateOrderNote(params) {
  return request({
    url:'/order/update/note',
    method:'post',
    params:params
  })
}

export function overview() {
  return request({
    url:'/order/admin/orderInfo/overview',
    method:'get',
  })
}

export function admingetOrderDetail(id) {
  return request({
    url:'/order/admin/orderDetail/get/'+id,
    method:'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/order.js